import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

export const firebaseConfig = {
    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    apiKey: "AIzaSyAccKu6M72kT--MXKbuCAPe2b_eVoEYYwM",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    projectId: "dollarstore-eab75",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};
 

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const storage = firebase.storage();
const firestore = firebase.firestore();

const environement = process.env.REACT_APP_FIREBASE_PROJECT_ID === 'dollarstore-eab75' ? "Production" : "Developpement"

if (process.env.REACT_APP_FIREBASE_USE_EMULATOR && window.location.hostname === 'localhost' && false) {
    auth.useEmulator('http://localhost:9099/');
    storage.useEmulator('localhost', 9199);
    firestore.useEmulator('localhost', 8080);
} else {
    auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() => console.log("persistance okay"))
        .catch((error) => console.error(error));

    firestore.settings({ cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED, merge:true });
    firestore.enablePersistence().catch(err => console.error(err));
}


export { auth, firestore, storage, environement, firebase as default }
